import createReduxForm from './createReduxForm';
import plain from './structure/plain';

export default createReduxForm(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/reduxForm.js
// module id = 1591
// module chunks = 0